import { render, staticRenderFns } from "./ResumenAcomodaciones.vue?vue&type=template&id=31a8aa59&"
import script from "./ResumenAcomodaciones.vue?vue&type=script&lang=js&"
export * from "./ResumenAcomodaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports